import React from 'react';
import { tools, languages } from '../data/resume_data';
import Bar from '../components/Bar';
import { motion } from 'framer-motion';
import { FaCertificate } from 'react-icons/fa';
import sideImage from '../assets/avatars/laptop2.svg';

const Resume = () => {
  const resume_variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.1,
        duration: 0.2,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        ease: 'easeInOut',
      },
    },
  };

  return (
    <motion.div
      className='container resume'
      variants={resume_variants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      <div className='row'>
        <div className='col-lg-6 resume-card'>
          <h4 className='resume-card__heading'>Career path</h4>
          <div className='resume-card__body'>
            {/* <h5 className='resume-card__title'>Computer Science Eng</h5> */}
            <a
              href='https://www.freecodecamp.org/certification/monsterkosh/responsive-web-design'
              className='resume-card__name'
              target='_blank'
              rel='noopener noreferrer'
            >
              <FaCertificate
                className='resume-card__icons'
                style={{ color: 'gold' }}
              />{' '}
              Responsive Web Design
            </a>
            <br />
            <a
              href='https://www.freecodecamp.org/certification/monsterkosh/javascript-algorithms-and-data-structures'
              className='resume-card__name'
              target='_blank'
              rel='noopener noreferrer'
            >
              <FaCertificate
                className='resume-card__icons'
                style={{ color: 'gold' }}
              />{' '}
              JavaScript Algorithms and Data Structures
            </a>
            <br />
            <a
              href='https://www.freecodecamp.org/certification/monsterkosh/front-end-libraries'
              className='resume-card__name'
              target='_blank'
              rel='noopener noreferrer'
            >
              <FaCertificate
                style={{ color: 'gold' }}
                className='resume-card__icons'
              />{' '}
              Front End Libraries
            </a>
            <br />
            <a
              href='https://www.freecodecamp.org/certification/monsterkosh/data-visualization'
              className='resume-card__name'
              target='_blank'
              rel='noopener noreferrer'
            >
              <FaCertificate
                className='resume-card__icons'
                style={{ color: 'gold' }}
              />{' '}
              Data Visualization
            </a>
            <br />
            <a
              href='https://www.freecodecamp.org/certification/monsterkosh/apis-and-microservices'
              className='resume-card__name'
              target='_blank'
              rel='noopener noreferrer'
            >
              <FaCertificate
                className='resume-card__icons'
                style={{ color: 'gold' }}
              />{' '}
              APIs and Microservices <br />
            </a>
          </div>
        </div>
        <div className='col-lg-6 resume-card'>
          <img src={sideImage} alt='side' className='resume-card__sideimage' />

          {/* <h4 className='resume-card__heading'>Experience</h4>
          <div className='resume-card__body'>

            <p className='resume-card__name'>
              Freelancer as Front-End Developer <br /> (since to Apr 2020 ~ )
            </p>
            <p className='resume-card__name'>
              IT Technician (from 2006 to 2021) <br />
              Part time - Family business
            </p>
          </div> */}
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-12 resume-languages'>
          <h5 className='resume-language__heading'>
            Some technologies I work with
          </h5>
        </div>
        <div className='col-lg-6 resume-languages'>
          <div className='resume-language__body mt-3'>
            {languages.map((language) => (
              <Bar value={language} />
            ))}
          </div>
        </div>
        <div className='col-lg-6 resume-languages '>
          {/* <h5 className='resume-language__heading'>Tools and software</h5> */}
          <div className='resume-language__body mt-3'>
            {tools.map((tool) => (
              <Bar value={tool} />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Resume;
